export default "__VITE_ASSET__CgqncFGP__"